<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout justify-center  row wrap v-if="fulfillmentData">
        <v-flex class="pa-4" xs12 sm10 md6 lg6 >
        <!--      service date similar to posted service-->
        <v-card>
          <v-card-title>
            <v-icon>event</v-icon>
            {{ momentDate(fulfillmentData.date) }}
          </v-card-title>
          <v-expansion-panels v-if="fulfillmentData.locations">
            <v-expansion-panel>
              <v-expansion-panel-header>
               <div class="subtitle-1"><v-icon>location_pin</v-icon> Locations</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row  v-if="fulfillmentData.crewMeetUpLocation">
                  <v-card-text>
                    <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + serviceData.routeDetails.meetUpLocation.formatted_address">
                      <div><v-icon class="red--text">location_pin</v-icon> {{serviceData.routeDetails.meetUpLocation.formatted_address}}</div>
                    </a>
                  </v-card-text>
                </v-row>
                <v-row>
                  <v-list v-if="fulfillmentData.locations">
                    <v-list-item v-if="fulfillmentData.locations.length === 0">
                      <v-list-item-avatar><v-icon>add_location</v-icon></v-list-item-avatar>
                      <v-list-item-content>
                        No locations
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="local in fulfillmentData.locations" :key="local.created">
                      <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + local.formatted_address">
                        <div><v-icon class="red--text">location_pin</v-icon> {{local.formatted_address}}</div>
                      </a>
                    </v-list-item>
                  </v-list>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>

        <!--      collapsed locations panel-->
        <!--      fixed timeline with checkin and clock in buttons-->
        <v-timeline dense>
          <v-slide-x-reverse-transition
              group
              hide-on-leave
          >
            <v-timeline-item
                color="blue"
                small
                :key="1"
            >
              <v-alert
                  :value="checkInAlert.display"
                  color="blue"
                  class="white--text"
              >
                <v-icon class="white--text">location_pin</v-icon>
                {{checkInAlert.message}}</v-alert>
              <v-card>
                <v-card-actions>
                  <v-btn>check in</v-btn>
                </v-card-actions>
              </v-card>
            </v-timeline-item>
            <v-timeline-item
                color="green"
                small
                :key="2"
                fill-dot
            >
              <v-card>
                <v-card-actions>
                  <v-btn outlined>clock in</v-btn>
                </v-card-actions>
              </v-card>
            </v-timeline-item>
          </v-slide-x-reverse-transition>
        </v-timeline>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
import {doc, onSnapshot} from 'firebase/firestore'
import moment from 'moment'
export default {
  props: ['fulfillmentId'],
  data: () => ({
    fulfillmentData: null,
    orderDetailsDialog: false,
    authDialog: false,
    checkInAlert: {display: true, message: 'Checked in at 9:26 AM'}
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    momentDate() {
      return (date) => {
        return moment(date).format('dddd, LL')
      }
    },
  },
  created () {
    let user = this.$store.getters.user
    let db = this.$store.state.db
    let fulfillmentDoc = doc(db, 'serviceProviders', user.phoneNumber,
        'fulfillment', this.fulfillmentId)
    onSnapshot(fulfillmentDoc, res => {
      if (res.exists) {
        let data = res.data()
        this.fulfillmentData = data
        console.log(data)
      }
    })
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

